import { render, staticRenderFns } from "./dialog-template.vue?vue&type=template&id=d7c2e0c4&scoped=true&"
import script from "./dialog-template.vue?vue&type=script&lang=js&"
export * from "./dialog-template.vue?vue&type=script&lang=js&"
import style0 from "./dialog-template.vue?vue&type=style&index=0&id=d7c2e0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c2e0c4",
  null
  
)

export default component.exports